module.exports = __webpack_public_path__ + "navigation.png?642ffd43cbd922b10392a15f0fbe0fb4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/navigation.png
// module id = 44
// module chunks = 0